import { useSomeActionIsLoadingSelector } from '@savgroup-front-common/core/src/domains/sagaRequestMetadata';

import { APPROVE_REJECT_QUOTE } from '../actionTypes';

export const useApproveOrRejectQuoteIsLoading = () => {
  return useSomeActionIsLoadingSelector([{ action: APPROVE_REJECT_QUOTE }]);
};
